import { mapVulnerabilityFilters } from '../../../graphql/schema/endpoint-helpers'
import { ThisConnector } from '../../connector'
import { VulnerabilityFilterArg } from '../shared/vulnerabilities'

export interface DeleteVulnerabilitieswithFiltersArgs {
  filters: VulnerabilityFilterArg
  organizationID: string
  excludedVulnerabilities: string[]
}

export async function deleteVulnerabilitiesWithFilters(
  this: ThisConnector,
  {
    filters,
    organizationID,
    excludedVulnerabilities
  }: DeleteVulnerabilitieswithFiltersArgs
) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { job_id, total } = await this.connector.executeDelete<{
    job_id: string
    total: number
  }>(`${organizationID}/orgtraces/bulk`, {
    filters: {
      ...mapVulnerabilityFilters(filters),
      excludedTraces: excludedVulnerabilities
    }
  })

  return {
    jobStatus: {
      id: job_id,
      total,
      progress: 0
    }
  }
}
